import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as appStore from '@appstore/*';
import { Page } from '@models/*';
import * as overviewStore from '@overviewstore/*';
import { ToastService } from '../../core/services/toast.service';

@Injectable()
export class TourStopGuard implements CanActivate {
  constructor(
    private toastService: ToastService,
    private store: Store<overviewStore.OverviewState | appStore.AppState>
  ) {}

  canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(overviewStore.getToursLoaded).pipe(
      filter((isComplete) => isComplete),
      take(1),
      mergeMap(() => zip(this.store.select(overviewStore.getCurrentStop), this.store.select(appStore.getRouterState))),
      take(1),
      map(([stop, routerState]) => {
        if (stop) {
          return true;
        } else {
          const params = routerState.state.params;
          this.store.dispatch(new appStore.RouterNavigate({ path: [`/tour/${params.tourId}`] }));
          this.toastService.generatePageRedirectToast(Page.STOP);
          return false;
        }
      })
    );
  }
}
